import { GenericIcon } from "@ppb/the-wall-icons/GenericIcon/GenericIcon";
import { FunctionComponent } from "react";
import styles from "./FunAndGaming.web.css";
import { FunAndGamingWebProps } from "./FunAndGaming.web.types";
import { StatusLabel } from "@ppb/the-wall-web";
import { StatusLabelSizeType, StatusLabelType } from "@ppb/the-wall-common/types";

const FunAndGaming: FunctionComponent<FunAndGamingWebProps> = ({ icon, tag, text, onPress }) => {
  return (
    <button className={styles.container} onClick={onPress}>
      <div className={styles.iconContainer}>
        <div className={styles.icon}>
          <GenericIcon name={icon} color="var(--sm-colours-icon-static-complimentary-base)" />
        </div>
      </div>
      <span className={styles.title}>{text}</span>
      {tag && (
        <div className={styles.label}>
          <StatusLabel
            text={tag}
            statusLabelType={StatusLabelType.GENEROSITY}
            statusLabelSize={StatusLabelSizeType.SMALL}
          />
        </div>
      )}
    </button>
  );
};

export default FunAndGaming;
